import Cell from '@/components/atoms/Cell'
import SectionHeader from '@/components/atoms/SectionHeader'
import { useScopedI18n } from '@/locales/client'
import useCartStore from '@/stores/CartStore'
import { useHubStore } from '@/stores/HubStore'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'
import { priceFormatter } from '@/util/formatter'

function PriceSection() {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()
  const t = useScopedI18n('priceSection')
  const hubs = useHubStore(state => state.hubs)
  const totalPerHub = useCartStore(store => store.totalPerHub())

  return (
    <section className={cn(
      'grid grid-cols-4 gap-1 tablet:grid-cols-5',
      isMobile && activeMobileTab === 'deluxe' && 'grid-cols-4',
    )}
    >
      <SectionHeader title={t('total')} className="col-span-2 grid grid-cols-2 tablet:grid-cols-2" />

      {hubs.map(hub => (
        <Cell
          key={hub.id}
          className={cn(
            'col-span-1',
            isMobile && activeMobileTab === 'deluxe' && 'col-span-2',
          )}
        >
          <p className="text-center text-lg font-bold leading-tight text-rsf-black">
            {priceFormatter((totalPerHub[hub.id] ?? 0), hub.pricing.currency)}
          </p>
        </Cell>
      ))}
    </section>
  )
}

export default PriceSection
